import {
  createUseStyles,
  // @ts-ignore
} from "@projectdiction/common-react";

const useStyles = createUseStyles({});

export default useStyles;
